import { COLORS, SEAT_SIZE } from '../constants';
import { Group } from 'konva/lib/Group';
import { Circle } from 'konva/lib/shapes/Circle';
import { Rect } from 'konva/lib/shapes/Rect';

class TableQuad {
	options: any = {};
	draggable = true;
	element = new Group({
		draggable: true,
	});
	shape: any;
	seats: any;
	sizes: any = {
		s: 50,
        m: 70,
        l: 90,
	}

	constructor(options = {}) {
		this.options = options;

		this.initShape();
		this.initSeats();
		this.reorder();
	}

	private initShape() {
		const size: any = this.sizes[`${this.options.size}`]; 
		this.shape = new Rect({
			x: 0,
			y: 0,
			width: size,
			height: size,
			fill: 'white',
			stroke: 'black',
			strokeWidth: 2,
			cornerRadius: 2,
		});

		this.element.add(this.shape);
	}

	private initSeats() {
		let seats = new Group({name: 'seats'});
		this.seats = seats;

		for (let i = 0; i < this.options.capacity; i++) {
			const seat = new Circle({
				x: 0,
				y: 0,
				radius: SEAT_SIZE,
				fill: COLORS.SEATS.INACTIVE,
			});

			seats.add(seat);
		}

		this.placeSeats();

		this.element.add(seats);
	}

	private placeSeats() {
		if (this.options.capacity == 2) {
			this.placeSeats2();
		}
		if (this.options.capacity == 4) {
			this.placeSeats4();
		}
		if (this.options.capacity == 8) {
			this.placeSeats8();
		}
		if (this.options.capacity == 12) {
			this.placeSeats12();
		}
	}

	private placeSeats2() {
		let seats = this.seats.children;

		seats[0].y(this.shape.height() / 2);

		seats[1].x(this.shape.width());
		seats[1].y(this.shape.height() / 2);
	}

	private placeSeats4() {
		let seats = this.seats.children;

		seats[0].y(this.shape.height() / 2);

		seats[1].x(this.shape.width() / 2);

		seats[2].x(this.shape.width());
		seats[2].y(this.shape.height() / 2);

		seats[3].x(this.shape.width() / 2);
		seats[3].y(this.shape.height());
	}

	private placeSeats8() {
		let seats = this.seats.children;

		let offset = 25;

		seats[0].y(this.shape.height() / 2 - offset);
		seats[1].y((this.shape.height() / 2) * 2 - offset);

		seats[2].y(this.shape.height() / 2 - offset);
		seats[3].y((this.shape.height() / 2) * 2 - offset);
		seats[2].x(this.shape.width());
		seats[3].x(this.shape.width());

		seats[4].x(this.shape.width() / 2 - offset);
		seats[5].x((this.shape.width() / 2) * 2 - offset);

		seats[6].x(this.shape.width() / 2 - offset);
		seats[7].x((this.shape.width() / 2) * 2 - offset);
		seats[6].y(this.shape.height());
		seats[7].y(this.shape.height());
	}

	private placeSeats12() {
		let seats = this.seats.children;

		let offset = 17.3;

		seats[0].y(this.shape.height() / 3 - offset);
		seats[1].y((this.shape.height() / 3) * 2 - offset);
		seats[2].y((this.shape.height() / 3) * 3 - offset);

		seats[3].y(this.shape.height() / 3 - offset);
		seats[4].y((this.shape.height() / 3) * 2 - offset);
		seats[5].y((this.shape.height() / 3) * 3 - offset);
		seats[3].x(this.shape.width());
		seats[4].x(this.shape.width());
		seats[5].x(this.shape.width());

		seats[6].x(this.shape.width() / 3 - offset);
		seats[7].x((this.shape.width() / 3) * 2 - offset);
		seats[8].x((this.shape.width() / 3) * 3 - offset);

		seats[9].y(this.shape.height());
		seats[10].y(this.shape.height());
		seats[11].y(this.shape.height());
		seats[9].x(this.shape.width() / 3 - offset);
		seats[10].x((this.shape.width() / 3) * 2 - offset);
		seats[11].x((this.shape.width() / 3) * 3 - offset);
	}

	private reorder() {
		this.element.children[1].zIndex(0);
	}
}

export default TableQuad;
